import { render, staticRenderFns } from "./FieldType21Configure.vue?vue&type=template&id=41c95c4d&scoped=true"
import script from "./FieldType21Configure.vue?vue&type=script&lang=js"
export * from "./FieldType21Configure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c95c4d",
  null
  
)

export default component.exports